export enum GqlError {
  InternalServerError = 'Internal Server Error',
  NetworkError = 'Network Error',
  UserNotFound = 'User not Found',
  DOWNSTREAM_SERVICE_ERROR = 'DOWNSTREAM_SERVICE_ERROR',
}
